import { AxiosResponse } from 'axios';
import FileSaver from 'file-saver';

export const saveFile = (response: AxiosResponse<Blob>, fileName?: string) => {
  const contentDisposition = response.headers['content-disposition'];
  const match = contentDisposition?.match(/filename=([^;]+)/);
  const matchedFileName = match?.[1];

  FileSaver.saveAs(response.data, fileName || matchedFileName);
};
